import { isTenantSubdomainHost } from '@/lib/tenantHost';

export function buildPlayEventPublicPath(orgSlug: string, eventSlug: string): string {
  if (typeof window !== 'undefined' && isTenantSubdomainHost()) {
    return `/play/${encodeURIComponent(eventSlug)}`;
  }
  return `/club-academy/${encodeURIComponent(orgSlug)}/play/${encodeURIComponent(eventSlug)}`;
}

export function buildPlayEventPublicUrl(orgSlug: string, eventSlug: string): string {
  if (typeof window === 'undefined') {
    return buildPlayEventPublicPath(orgSlug, eventSlug);
  }
  return `${window.location.origin}${buildPlayEventPublicPath(orgSlug, eventSlug)}`;
}

export function buildPlayEventPublicBoardPath(orgSlug: string, eventSlug: string): string {
  if (typeof window !== 'undefined' && isTenantSubdomainHost()) {
    return `/play/${encodeURIComponent(eventSlug)}/board`;
  }
  return `/club-academy/${encodeURIComponent(orgSlug)}/play/${encodeURIComponent(eventSlug)}/board`;
}

export function buildPlayEventPublicBoardUrl(orgSlug: string, eventSlug: string): string {
  if (typeof window === 'undefined') {
    return buildPlayEventPublicBoardPath(orgSlug, eventSlug);
  }
  return `${window.location.origin}${buildPlayEventPublicBoardPath(orgSlug, eventSlug)}`;
}
